// extracted by mini-css-extract-plugin
module.exports = {"EmptyState":"empty_state_EmptyState__1h8st","illustration":"empty_state_illustration__1DasP","details":"empty_state_details__jVHhi"};